import React from "react";
import "./Image.scss";

function Image({ imgSrc }) {
  return (
    <div className="custom-image">
      <img src={imgSrc} alt=""/>
    </div>
  );
}

export default Image;
